import { defineMessages } from "react-intl";
const messages = defineMessages({
    noScanCompleted: {
        id: "app.scanCompleted.table.tooltip.noData",
        defaultMessage: "No completed scans available.",
    },
    onsiteRequest: {
        id: "app.scanCompleted.table.column.onsiteRequest",
        defaultMessage: "OnSite Request",
    },
    scannedOn: {
        id: "app.scanCompleted.table.column.scannedOn",
        defaultMessage: "Scanned On",
    },
    scannedBy: {
        id: "app.scanCompleted.table.column.scannedBy",
        defaultMessage: "Scanner",
    },
    organization: {
        id: "app.scanCompleted.table.column.organization",
        defaultMessage: "Organization",
    },
    community: {
        id: "app.scanCompleted.table.column.community",
        defaultMessage: "Community",
    },
    space: {
        id: "app.scanCompleted.table.column.space",
        defaultMessage: "Space",
    },
    floorPlan: {
        id: "app.scanCompleted.table.column.floorPlan",
        defaultMessage: "Floorplan",
    },
    address: {
        id: "app.scanCompleted.table.column.address",
        defaultMessage: "Address",
    },
    layout: {
        id: "app.scanCompleted.table.column.layout",
        defaultMessage: "Layout",
    },
    requestedBy: {
        id: "app.scanCompleted.table.column.requestedBy",
        defaultMessage: "Requested by",
    },
});
export default messages;
